module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "row center-block"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.idioma === 'DE') ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [_vm._v("Nutzername")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarNomeUsuario()
      }
    }
  }, [_vm._v("Datensatzname")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarSenhaUsuario()
      }
    }
  }, [_vm._v("Passwort neu definieren")])])])]) : (_vm.idioma === 'EN') ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [_vm._v("User name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarNomeUsuario()
      }
    }
  }, [_vm._v("Save name")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarSenhaUsuario()
      }
    }
  }, [_vm._v("Redefine password")])])])]) : (_vm.idioma === 'ES') ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [_vm._v("Nombre de usuario")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarNomeUsuario()
      }
    }
  }, [_vm._v("Guardar nombre")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarSenhaUsuario()
      }
    }
  }, [_vm._v("Redefinir contraseña")])])])]) : _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [_vm._v("Nome do Usuário")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarNomeUsuario()
      }
    }
  }, [_vm._v("Gravar Nome")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarSenhaUsuario()
      }
    }
  }, [_vm._v("Redefinir Senha")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-449577a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Usuario.vue
// module id = 676
// module chunks = 1